/**
 * List of allowed hosts across DSG properties used for
 * validation of SSR requests.
 *
 * https://github.com/angular/angular-cli/security/advisories/GHSA-x288-3778-4hhx
 */
export const ALLOWED_SERVER_HOSTS = [
  'localhost',
  '*.dcsg.com',
  '*.dickssportinggoods.com',
  '*.dksxchange.com',
  '*.goinggoinggone.com',
  '*.golfgalaxy.com',
  '*.publiclands.com',
] as const;
